import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions';
import FieldTextArea from './FieldTextArea';
import StarRating from './StarRating';
import RadioAnswers from './RadioAnswers';
import CheckboxAnswers from './CheckboxAnswers';
import { find } from 'lodash';
import { isQuestionResponseValid } from '../utils';

class SurveyPageWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  handleChange(value, questionData, typeOfResponse) {
    this.props.handleQuestionResponseChange(questionData, value, typeOfResponse)
  }

  handleCheckboxChange(value, questionData, typeOfResponse, isChecked) {
    if(isChecked) {
      this.props.addAnswerIdsToQuestionResponse(questionData, value, typeOfResponse);
    } else {
      this.props.removeAnswerIdsToQuestionResponse(questionData, value, typeOfResponse);
    }
  }

  getValueForQuestion(type, surveyQuestionResponse) {
    if(surveyQuestionResponse) {
      return surveyQuestionResponse[type];
    } else {
      return null;
    }
  }

  render() {
    const { surveyPage, surveyResponse, currentPage, validateCurrentPage } = this.props;
    return(
      <div>
        {surveyPage.questions.map((question, question_index) => {
          let surveyQuestionResponse = find(surveyResponse.questionResponses, { 'question_id': question.id });
          let hasError = (validateCurrentPage && !isQuestionResponseValid(surveyQuestionResponse));
          let wrapperClass = question_index != 0 ? "pt3 question-wrapper" : "question-wrapper";
          return(
            <div key={`question-${question.id}`} className={wrapperClass}>
              {question.required &&
                <div className="cs-pill cs-pill-blue-alt-two mb1">Required</div>
              }
              <div>
                <label className="survey-question-label m0">{question.name}</label>
              </div>
              {question.answers.length > 0 && question.answer_style == "radio" &&
                <div className="py1">
                  <RadioAnswers
                    onChange={this.handleChange}
                    questionData={question}
                    value={this.getValueForQuestion("answer_id", surveyQuestionResponse)}
                  />
                </div>
              }
              {question.answers.length > 0 && question.answer_style == "checkboxes" &&
                <div className="py1">
                  <CheckboxAnswers
                    onChange={this.handleCheckboxChange}
                    questionData={question}
                    answerIds={this.getValueForQuestion("answer_ids", surveyQuestionResponse)}
                  />
                </div>
              }
              {question.show_five_star &&
                <div className="py1">
                  <StarRating
                    onChange={this.handleChange}
                    questionData={question}
                    value={this.getValueForQuestion("star_rating", surveyQuestionResponse)}
                  />
                </div>
              }
              {question.show_comments &&
                <div className="py1">
                  <FieldTextArea
                    onChange={this.handleChange}
                    questionData={question}
                    required={question.required}
                    className="mb-input-gray br2"
                    value={this.getValueForQuestion("response", surveyQuestionResponse)}
                  />
                </div>
              }
              {hasError &&
                <div className="question-error cs-red-error">
                  Must answer this question
                </div>
              }
            </div>
          )
        })}
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(null, mapDispatchToProps)(SurveyPageWrapper);
